function InitFormPopup() {
  const popupWrapper = document.querySelector(".formPopupWrapper");
  const popupOverlay = document.querySelector(".formPopupOverlay");

  if (!popupWrapper || !popupOverlay) return;

  const openPopup = () => {
    popupWrapper.classList.add("active");
    popupOverlay.classList.add("active");
    document.documentElement.classList.add("overflow-hidden");
  };

  const closePopup = () => {
    popupWrapper.classList.remove("active");
    popupOverlay.classList.remove("active");
    document.documentElement.classList.remove("overflow-hidden");
  };

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest(".openFormPopup");
    const closeBtn = e.target.closest(".closeFormPopup");

    if (openBtn) {
      e.preventDefault();
      openPopup();
      return;
    }

    if (closeBtn) {
      e.preventDefault();
      closePopup();
      return;
    }

    if (e.target === popupOverlay) {
      closePopup();
    }
  });
}

export default InitFormPopup;